import { ApplicationConfig } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { APP_INITIALIZER } from '@angular/core';
import {
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { routes } from './app.routes';
import { AuthService } from './modules/auth/services/auth.service';
import { SessionService } from './core/services/session.service';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';

/**
 * App initialization factory
 * 1. Checks if user is authenticated (via cookie)
 * 2. If authenticated, creates session activity and starts heartbeat
 * 3. If not authenticated, does nothing (auth guard will handle redirect)
 */
function initializeApp(
  sessionService: SessionService,
  authService: AuthService
) {
  return async () => {
    try {
      // check if user is authenticated
      const isAuthenticated = await authService.isAuthenticatedAsync();

      if (isAuthenticated) {
        // Create session if user is authenticated
        await sessionService.createSessionActivity();
      }
    } catch (error) {
      console.error('App initialization error:', error);
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'top' })
    ),
    provideAnimationsAsync(),
    // withInterceptorsFromDi() is required for HTTP_INTERCEPTORS classes to be applied.
    provideHttpClient(withFetch(), withInterceptorsFromDi()),

    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [SessionService, AuthService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
};
